<eui-common-header [label]="label" [subLabel]="subLabel" [isCollapsed]="isCollapsed">
    <div class="eui-page-header__action-items">
        <ng-content select="eui-page-header-action-items"></ng-content>
    </div>
</eui-common-header>

<eui-expand-content *ngIf="isCollapsible" [isCollapsed]="isCollapsed"
                    (collapsed)="onToggle($event)"
                    [expandLabel]="expandedLabel"
                    [collapseLabel]="collapsedLabel">
    <ng-container *ngTemplateOutlet="body"></ng-container>
</eui-expand-content>

<ng-container *ngIf="!isCollapsible && customPageHeaderBodyContent">
    <ng-container *ngTemplateOutlet="body"></ng-container>
</ng-container>

<ng-template #body>
    <div class="eui-page-header__body">
        <ng-content select="eui-page-header-body"></ng-content>
    </div>
</ng-template>
